<script lang="ts">
  import type { LayoutProps } from './$types';
  import { page } from '$app/state';
  import ClassInfoLayout from '$lib/components/classes/ClassInfoLayout.svelte';

  let { params, data, children }: LayoutProps = $props();

  let activePage: 'students' | 'classInfo' = $derived.by(() => {
    if (page.route.id === '/(loginwrapper)/instructors/classes/[id]/students') {
      return 'students';
    }

    return 'classInfo';
  });
</script>

<ClassInfoLayout classId={params.id} classPromise={data.classPromise} {activePage} hrefPrefix="/instructors">
  {@render children?.()}
</ClassInfoLayout>
